import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { customerActions } from "@sonic/Store/GemecoState";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<{}, DispatchProp<customerActions>>;

export const ToggleOrdersFilter: HandlerType = props => {
    props.dispatch({
        type: "Pages/WorkOrderHistory/ToggleFiltersOpen",
    });
};

export const chain = [ToggleOrdersFilter];

const toggleFiltersOpen = createHandlerChainRunnerOptionalParameter(chain, {}, "ToggleFiltersOpen");
export default toggleFiltersOpen;
